/**
 * Opens a new, minimally-styled window containing only the given body
 * markup and triggers the browser's print dialog -- the simplest
 * reliable way to get an isolated, print-friendly view (Part 6 "print-
 * friendly invoice and packing-slip views") without maintaining a
 * `@media print` stylesheet against the full admin app's own layout
 * (sidebar/nav/filters would all need explicit `print:hidden` handling
 * otherwise). `bodyHtml` must already be escaped by the caller -- this
 * function does no sanitization of its own, matching the same
 * caller-escapes convention used by the notification email templates.
 */
export function printHtml(title: string, bodyHtml: string): void {
  const printWindow = window.open('', '_blank', 'noopener,noreferrer');
  if (!printWindow) return;
  printWindow.document.write(`<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <title>${title}</title>
    <style>
      body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #1A1A1A; padding: 24px; }
      table { width: 100%; border-collapse: collapse; margin-top: 12px; }
      th, td { text-align: left; padding: 6px 8px; border-bottom: 1px solid #EDE9DD; font-size: 13px; }
      th { color: #5C5C52; font-weight: 600; }
      h1 { font-size: 18px; margin-bottom: 4px; }
      h2 { font-size: 14px; margin-top: 20px; margin-bottom: 4px; }
      .muted { color: #5C5C52; font-size: 13px; }
      .totals td { border-bottom: none; }
      .totals .label { text-align: right; color: #5C5C52; }
      .totals .value { text-align: right; font-variant-numeric: tabular-nums; }
    </style>
  </head>
  <body>${bodyHtml}</body>
</html>`);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
}
